<template>
  <div>
    
    <Cbarra>
        <template slot="slotTitle">Contactos de Emergencia</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <router-link :to="{name:'enesresponde'}">ENES Responde</router-link>
        </template>
    </Cbarra>

    <section class="container">
        <div class="bg-principal">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 shadow_principal">
                    <div class="nav flex-column nav-pills bolt mt-4 mb-5" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-uno-tab" data-toggle="pill" href="#v-pills-uno"
                            role="tab" aria-controls="v-pills-uno" aria-selected="true">
                            Servicios de Emergencia
                        </a>
                        <a class="nav-link" id="v-pills-dos-tab" data-toggle="pill" href="#v-pills-dos" role="tab"
                            aria-controls="v-pills-dos" aria-selected="false">
                            Servicios Médicos
                        </a>
                        <a class="nav-link" id="v-pills-tres-tab" data-toggle="pill" href="#v-pills-tres" role="tab"
                            aria-controls="v-pills-tres" aria-selected="false">
                            Programa de Atención a la Salud Emocional (PASE)
                        </a>
                        <div class="nav-link title-call">
                            Oficina Jurídica <i class="fas fa-angle-down color8 ml-1"></i>
                        </div>
                        <a class="nav-link sub-menu" id="v-pills-cuatro-tab" data-toggle="pill" href="#v-pills-cuatro"
                            role="tab" aria-controls="v-pills-cuatro" aria-selected="false">
                            Introducción
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-cinco-tab" data-toggle="pill" href="#v-pills-cinco"
                            role="tab" aria-controls="v-pills-cinco" aria-selected="false">
                            Funciones
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-seis-tab" data-toggle="pill" href="#v-pills-seis"
                            role="tab" aria-controls="v-pills-seis" aria-selected="false">
                            Atención Alumnos
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-siete-tab" data-toggle="pill" href="#v-pills-siete"
                            role="tab" aria-controls="v-pills-siete" aria-selected="false">
                            Principal Normativa
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-ocho-tab" data-toggle="pill" href="#v-pills-ocho"
                            role="tab" aria-controls="v-pills-ocho" aria-selected="false">
                            Ligas de Interés
                        </a>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
                    <div class="tab-content mt-4 mb-5" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="v-pills-uno" role="tabpanel"
                            aria-labelledby="v-pills-uno-tab">
                            <h3 class="color_Azul family-01">Contactos de Emergencia</h3>
                            <hr class="divider-02 hr-sm-left-0 bg-color">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="far fa-siren-on icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul"> Emergencias</h5>
                                                </div>
                                            </div>

                                            <h6 class="titulo-eme-red"><a href="tel:911">911</a></h6>
                                            <p>
                                                Número Único de Emergencias en todo el país. A través de estos tres
                                                números se atenderán, vía telefónica, incidentes médicos, de seguridad,
                                                protección civil y servicios públicos.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="fas fa-user-secret icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul">Denuncia anónima</h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red">
                                                <a href="tel:089">089</a></h6>
                                            <p>
                                                Atiende las 24 horas del día los 365 días del año denuncias sobre venta
                                                de drogas, violencia intrafamiliar, secuestro, maltrato, homicidio,
                                                robo, violación, pandillerismo, falsificación de documentos, armas,
                                                explosivos, corrupción, entre otras. No identifica
                                                el número del que realiza la llamada ni solicita su nombre o datos que
                                                pongan en riesgo su integridad física. La denuncia se canaliza a las
                                                dependencias responsables para actuar en caso de ser necesario.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="fas fa-shield-alt icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul">Secretaría de Seguridad Pública
                                                        del Estado de Yucatán</h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red"><a href="tel:tel:+529999303200">999 930 3200</a>
                                            </h6>
                                            <p>
                                                <b>Puedes llamar desde líneas Telcel sin costo marcando <a href="tel:113">113</a></b>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="fal fa-fire-extinguisher icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul">Bomberos del Estado de Yucatán
                                                    </h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red"><a href="tel:+529999249242">999 924 9242</a></h6>
                                            <p>
                                                Puedes llamar desde líneas Telcel sin costo marcando <a
                                                    href="tel:116"><b>116</b></a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="fas fa-first-aid icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul">Cruz Roja</h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red">
                                                <a href="tel:911">911</a> /
                                                <a href="tel:+529999830227">999 983 0227</a>,
                                                <a href="tel:+529999830306">999 983 0306</a></h6>
                                        </div>
                                    </div>
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="far fa-user-hard-hat icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul">Unidad Estatal de Protección Civil
                                                    </h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red"><a href="tel:+529999442688">999 944 2688,</a> <a
                                                    href="tel:+529999442470">999 944 2470</a>, <a
                                                    href="tel:+528007198633">800 719 8633</a></h6>
                                            <p>
                                                Puedes llamar desde líneas Telcel sin costo marcando <a
                                                    href="tel:118"><b>118</b></a>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="fal fa-ambulance icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul">Ambulancias</h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red"><a href="tel:+529999830243">999 983 0243</a></h6>
                                        </div>
                                    </div>
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="fad fa-siren-on icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul">Policía de Mérida</h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red"><a href="tel:+529999420060">999 942 0060</a></h6>
                                        </div>
                                    </div>
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="far fa-user-tie icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul">Fiscalía General del Estado</h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red">
                                                <a href="tel:066">066</a> /
                                                <a href="tel:+529999303200">999 930 3200</a></h6>
                                        </div>
                                    </div>
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="far fa-user-shield icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul">Protección Civil de Mérida</h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red"><a href="tel:+529999248769>">999 924 8769</a>, <a
                                                    href="tel:+529999235336">999 923 5336</a> Ext. 109 y 111. Línea
                                                Directa: <a href="tel:+529999288311">999 928 8311</a></h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="v-pills-dos" role="tabpanel" aria-labelledby="v-pills-dos-tab">
                            <h4 class="mb-3">Servicios Médicos</h4>
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="fas fa-clinic-medical icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul"> Clínica IMSS T1</h5>
                                                </div>
                                            </div>
                                            <ul class=" list-icon">
                                                <li>Directo <a href="tel:+529999225656"><b>999 922 5656</b></a></li>
                                                <li>Urgencias <a href="tel:+529999420111"><b>999 942 0111</b></a></li>
                                                <li>Ambulancias <a href="tel:+529999420114"><b>999 942 0114</b></a></li>
                                                <li>Admisión al hospital <a href="tel:+529999420112"><b>999 942
                                                            0112</b></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="far fa-hospital-symbol icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul"> ISSSTE Hospital Regional “Mérida”
                                                    </h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red">
                                                <a href="tel:+529999250402">925 04 02</a> y
                                                <a href="tel:+529999640000">964 00 00</a></h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="fas fa-clinic-medical icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul"> ISSSTE, Clínica Lindavista</h5>
                                                </div>
                                            </div>
                                            <h6 class="titulo-eme-red">
                                                <a href="tel:+529999877563">987 75 63</a> y
                                                <a href="tel:+529999877564">987 75 64</a></h6>
                                        </div>
                                    </div>
                                    <div class="card card-eme mb-3">
                                        <div class="card-body">
                                            <div class="tm-item">
                                                <div class="tm-name">
                                                    <i class="fas fa-clinic-medical icon-emergencia"></i>
                                                </div>
                                                <div class="tm-description">
                                                    <h5 class="titulo-eme color_Azul"> ISSSTE Susulá</h5>
                                                </div>
                                            </div>
                                            <p>
                                                (a solo 5 minutos de la ENES) Calle 21 S/N, Colonia Comisaráa de Susulá,
                                                Mérida, Yucatán, C.P. 97314
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="v-pills-tres" role="tabpanel" aria-labelledby="v-pills-tres-tab">
                            <h3 class="color_Azul family-01">Programa de Atención a la Salud Emocional (PASE)</h3>
                            <hr class="divider-02 hr-sm-left-0 bg-color">
                            <figure>
                                <img src="../../assets/style/images/fotos/pase_2.jpg" alt="" class="w-100 img-thumbnail effect2">
                            </figure>

                            <div class="row mt-4">
                                <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 text-center">
                                    <img src="../../assets/style/images/logos/pases.png" alt="PASES"
                                        class="img-fluid img-thumbnail effect2">
                                </div>
                                <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
                                    <p>
                                        El PASE tiene como misión generar una cultura de salud mental a través de la
                                        promoción e implementación de acciones y estrategias orientadas a dos tareas
                                        fundamentales:
                                    </p>
                                    <ul class="list-icon d-none d-lg-block">
                                        <li>Bienestar emocional a través de la promoción de la salud</li>
                                        <li>Prevención de enfermedades y malestares psicológicos que afectan a los
                                            estudiantes y a la comunidad universitaria en general.</li>
                                    </ul>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-block d-lg-none">
                                    <ul class="list-icon">
                                        <li>Bienestar emocional a través de la promoción de la salud</li>
                                        <li>Prevención de enfermedades y malestares psicológicos que afectan a los
                                            estudiantes y a la comunidad universitaria en general.</li>
                                    </ul>
                                </div>
                            </div>

                            <h5 class="color_Azul mt-4 mb-4">PASE cuenta con tres ejes de acción:</h5>
                            <ul class="list-icon">
                                <li>
                                    <b>Promoción, prevención y atención del bienestar emocional:</b> Acciones centradas
                                    en la valoración, atención y seguimiento psicológico de la comunidad del campus de
                                    la UNAM en Yucatán
                                </li>
                                <li>
                                    <b>Investigación:</b> Las acciones preventivas son planteadas con base en el
                                    conocimiento situado, considerando el contexto y las personas (comunidad) a través
                                    del diagnóstico comunitario sobre malestares de la salud
                                    mental.
                                </li>
                                <li>
                                    <b>Difusión y vinculación institucional:</b> Promover convenios generales y
                                    específicos con organismos oficiales y delegaciones gubernamentales que apoyen
                                    diversas iniciativas de este Programa.
                                </li>
                            </ul>
                            <hr class="divider-01">

                            <div class="row justify-content-center">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div class="highlight">
                                        <h4 class="color_Azul family-01">Equipo PASE</h4>
                                        <hr class="divider-02 hr-sm-left-0 bg-color">
                                        <h6 class="color_Azul">Coordinadora del PASE</h6>
                                        <ul class="list-icon">
                                            <li>Dra Fátima Flores Palacios</li>
                                        </ul>
                                        <h6 class="color_Azul">Terapeutas</h6>
                                        <ul class="list-icon">
                                            <li>Dra Nelly Ruz Sanguino</li>
                                            <li>Mtra. Isaura Rojano Gallegos</li>
                                            <li>Mtra. Verónica Gaxiola Cortés</li>
                                        </ul>
                                    </div>

                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div class="contacto_pase">
                                        <h4 class="color_Azul family-01">Contacto</h4>
                                        <hr class="divider-02 hr-sm-left-0 bg-color">
                                        <ul class="list-icon">
                                            <li>
                                                Informes y citas para atención en el correo: <a
                                                    href="mailto:pase@enesmerida.unam.mx"><b>pase@enesmerida.unam.mx</b></a>
                                            </li>
                                            <li>
                                                El módulo de atención se encuentra en: Casa Lol Be: Calle 22 #199, x 19
                                                y 21, García Ginerés, 97070, Mérida, Yuc.
                                            </li>
                                        </ul>

                                        <p class="text-center mt-5 mb-1">
                                            <a class="button" download="Calendario sesiones del HCT 2021"
                                                href="https://www.facebook.com/PASE-109429547388345">
                                                <span class="fab fa-facebook-square fa-lg"></span> Facebook PASE
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                        <div class="tab-pane fade" id="v-pills-cuatro" role="tabpanel"
                            aria-labelledby="v-pills-cuatro-tab">
                            <div  v-for="(lista,key) in objTab1.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->
                        </div>
                        
                        <div class="tab-pane fade" id="v-pills-cinco" role="tabpanel"
                            aria-labelledby="v-pills-cinco-tab">
                            <div  v-for="(lista,key) in objTab2.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-seis" role="tabpanel"
                            aria-labelledby="v-pills-seis-tab">
                            <div  v-for="(lista,key) in objTab3.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-siete" role="tabpanel"
                            aria-labelledby="v-pills-siete-tab">
                            <div  v-for="(lista,key) in objTab4.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-ocho" role="tabpanel"
                            aria-labelledby="v-pills-ocho-tab">
                            <div  v-for="(lista,key) in objTab5.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

  </div>
</template>

<script>
export default {
    data() {
        return {
            urlApi:"inicio/investigacion",
            ListaContenido:[],
            oferta:{},
            Segurity:{},
            ConfCatalogo:{
				title:'Investigacion',
				isModal: true,
				obj: {}
            },
            ConfFiltro:{
				placeHSearch:'Puesto',
				valueSearch:'',
				entrada:25,
				pag:1,
				totalItems:0,
				pageSize:0,
            },
            ConfAcciones:{
            },
            ConfigBtnModal2:{
                emitAdd: 'NuevoModal2',
                emitDel: 'EliminarDetalle'
            },
			ConfModal: {
				ShowPie: true,
                Size:'md',
            },
            oBoton1:{
                NameOk:'Crear',
                ShowPie:true,
            },
            oModal2:{
                Titulo: 'Detalles del Tema',
                Size:'lg',
            },
            oBoton2:{
                TipoModal:2,
                ShowPie:true,
            },
            objTema1:{
                editar:false,
                Apartado: 'ENESINTRO',
                Realiza: 'AddTema'
            },
            objTab1:{
                editar:false,
                Apartado: 'ENESINTRO',
                ListaDet: [],
            },

            objTema2:{
                editar:false,
                Apartado: 'ENESFUNCIONES',
                Realiza: 'AddTema'
            },
            objTab2:{
                editar:false,
                Apartado: 'ENESFUNCIONES',
                ListaDet: [],
            },

            objTema3:{
                editar:false,
                Apartado: 'ENESATENCION',
                Realiza: 'AddTema'
            },
            objTab3:{
                editar:false,
                Apartado: 'ENESATENCION',
                ListaDet: [],
            },

            objTema4:{
                editar:false,
                Apartado: 'ENESPRINCIPAL',
                Realiza: 'AddTema'
            },
            objTab4:{
                editar:false,
                Apartado: 'ENESPRINCIPAL',
                ListaDet: [],
            },

            objTema5:{
                editar:false,
                Apartado: 'ENESLIGAINTERES',
                Realiza: 'AddTema'
            },
            objTab5:{
                editar:false,
                Apartado: 'ENESLIGAINTERES',
                ListaDet: [],
            },
            RutaFile: '',
            RutaFileD: '',
            listIconos: [],    
        }
    },methods: {
        async Lista()
        {
            await this.$http.get(this.urlApi, {
					params:{Seccion:'ENESRESPONDE',TxtBusqueda:'',Entrada:'',pag:'',RegEstatus: 'A',Orden:'SI'}
                }
            ).then((res) => {
				this.ConfFiltro.pag			= res.data.pagination.CurrentPage;
				this.ConfFiltro.totalItems 	= res.data.pagination.TotalItems;
				this.ConfFiltro.pageSize	= res.data.pagination.PageSize;
                this.Segurity				= res.data.segurity;
                this.RutaFile               = res.data.RutaFile;
                this.RutaFileD              = res.data.RutaFileD;
                this.listIconos             = res.data.listIconos;
                
                let newObj1 = [];
                let newObj2 = [];
                let newObj3 = [];
                let newObj4 = [];
                let newObj5 = [];

               
                $.each(res.data.tema, function(key, value)
                {
                    if(value.Apartado == 'ENESINTRO'){
                        newObj1.push(value)
                    }
                    else if(value.Apartado == 'ENESFUNCIONES'){
                        newObj2.push(value)
                    } 
                    else if(value.Apartado == 'ENESATENCION'){
                        newObj3.push(value)
                    }                     
                    else if(value.Apartado == 'ENESPRINCIPAL'){
                        newObj4.push(value)
                    }  
                    else if(value.Apartado == 'ENESLIGAINTERES'){
                        newObj5.push(value)
                    }  
                });
                if(newObj1.length > 0){
                    this.objTab1.editar = true;
                    this.objTab1.ListaDet = newObj1;
                }
                if(newObj2.length > 0){
                    this.objTab2.editar = true;
                    this.objTab2.ListaDet = newObj2;
                }
                if(newObj3.length > 0){
                    this.objTab3.editar = true;
                    this.objTab3.ListaDet = newObj3;
                }
                if(newObj4.length > 0){
                    this.objTab4.editar = true;
                    this.objTab4.ListaDet = newObj4;
                }
                if(newObj5.length > 0){
                    this.objTab5.editar = true;
                    this.objTab5.ListaDet = newObj5;
                }
            });
        },

         iconoFiltrado(buscar)
        {
            let aBuscar = buscar;
            let devuelve = '';
            let arr = this.listIconos.filter(function(vl){
                if(aBuscar!=''){
                    if(aBuscar == vl.Id){
                        return vl;
                    }
                    else{
                        return '';
                    }
                }
            });

            if(arr[0]){
                devuelve = arr[0].Icono;
            }
            
            return devuelve;
        },
    },mounted() {
        window.scrollTo(0, 0);
        this.Lista();
    },
}
</script>